import * as React from "react";

const SvgUndeleteDocument = (props) => {
  const { fill = "currentColor", width = 15, height = 15 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 0.75H2.2425C1.41 0.75 0.7575 1.425 0.7575 2.25L0.75 12.75C0.75 13.575 1.41 14.25 2.2425 14.25H12.75C13.575 14.25 14.25 13.575 14.25 12.75V2.25C14.25 1.425 13.575 0.75 12.75 0.75ZM12.75 9.75H9.75C9.75 10.995 8.7375 12 7.5 12C6.2625 12 5.25 10.995 5.25 9.75H2.2425V2.25H12.75V9.75Z"
        fill={fill}
      />
      <path d="M6 6.75H4.5L7.5 3.75L10.5 6.75H9V9H6L6 6.75Z" fill={fill} />
    </svg>
  );
};

export default SvgUndeleteDocument;
